import moment from 'moment';
import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { RRule } from 'rrule';
import _ from 'lodash';
import {
  EVENT_SOURCE,
  STATUS_LIST,
  APPROVAL_OPTIONS,
  ATTRIBUTE_TYPE_IN_TASK,
} from '../../../../../HelperMethods/enums';
import * as RRuleFunctions from '../../../../../HelperMethods/RRuleFunctions';
import {
  capitalizeFirstLetter,
  findRequiredEntities,
  findSelectedEntity,
  findValueInAnyParentElement,
  findUniqueOptionsIds,
  findRequiredOptionForMetatdata,
  findUniqueOptionsIdsForElementType,
  getUniqueOptionsForDynamicList,
  findElementValueAndPicklistId,
} from '../../../../../HelperMethods/UtilityFunctions';
import { FormField, isFormAttributeHiddenOrInvalid } from '../../../../../HelperMethods/FormUtils';
/* eslint-disable */
export const INPUT_TYPE_FORMAT = {
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
};

export const ON_TASK_TYPE_CHANGE_FOR_LINKED_TASKS = 'onTaskTypeChangeForLinkedTasks';

export const TASK_FORM_MODE = {
  UPDATE: 'TASK_FORM_MODE_UPDATE',
  CREATE: 'TASK_FORM_MODE_CREATE',
};

export const RRULE_FREQUENCY_MAP = {
  [RRule.MONTHLY]: 'monthly',
  [RRule.WEEKLY]: 'weekly',
  [RRule.DAILY]: 'daily',
};

export const RecurringFormFields = ({ attributeObj, formik, disabled, ...props }) => {
  return (
    <Grid className="joyn2-grid">
      <Grid.Row>
        <Grid.Column width={8}>
          <div
            className="tab"
            style={{
              borderBottom: '1px solid #e5e5e5',
              background: 'none',
              marginTop: '2px',
            }}
          >
            <label
              className={`tablinks ${
                _.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.DAILY]
                  ? 'selected'
                  : ''
              }`}
            >
              <input
                type="radio"
                name="schedule_recurring.frequencytype"
                value={RRULE_FREQUENCY_MAP[RRule.DAILY]}
                checked={_.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.DAILY]}
                onChange={formik.handleChange}
                disabled={disabled}
              />
              Daily
            </label>
            <label
              className={`tablinks ${
                _.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.WEEKLY]
                  ? 'selected'
                  : ''
              }`}
            >
              <input
                type="radio"
                name="schedule_recurring.frequencytype"
                value={RRULE_FREQUENCY_MAP[RRule.WEEKLY]}
                checked={_.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.WEEKLY]}
                onChange={formik.handleChange}
                disabled={disabled}
              />
              Weekly
            </label>
            <label
              className={`tablinks ${
                _.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.MONTHLY]
                  ? 'selected'
                  : ''
              }`}
            >
              <input
                type="radio"
                name="schedule_recurring.frequencytype"
                value={RRULE_FREQUENCY_MAP[RRule.MONTHLY]}
                checked={
                  _.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.MONTHLY]
                }
                onChange={formik.handleChange}
                disabled={disabled}
              />
              Monthly
            </label>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          {_.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.DAILY] && (
            <div>
              <div className="well">
                {'Every '}
                <select
                  name="schedule_recurring.dailyinterval"
                  value={_.get(formik.values, 'schedule_recurring.dailyinterval')}
                  onChange={formik.handleChange}
                  disabled={disabled}
                >
                  {_.range(1, 11).map((n) => {
                    return (
                      <option key={`${n}`} value={`${n}`}>
                        {n}
                      </option>
                    );
                  })}
                </select>
                {' day(s)'}
              </div>
            </div>
          )}
          {_.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.WEEKLY] && (
            <div className="well">
              {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => {
                return (
                  <div key={day}>
                    <input
                      type="checkbox"
                      name="schedule_recurring.byweekday"
                      value={`${index}`}
                      onChange={(e) => {
                        const byweekday = _.clone(_.get(formik.values, 'schedule_recurring.byweekday', []));
                        const weekday = RRuleFunctions.getRRuleWeekDay(index);
                        const weekdayIndex = byweekday.indexOf(weekday);
                        if (weekdayIndex > -1) {
                          byweekday.splice(weekdayIndex, 1);
                        } else {
                          byweekday.push(weekday);
                        }
                        formik.setFieldValue('schedule_recurring.byweekday', byweekday, false);
                      }}
                      style={{ marginTop: '4px', marginRight: '5px' }}
                      id={`id-${day}`}
                      checked={
                        _.get(formik.values, 'schedule_recurring.byweekday', [])
                          .map(RRuleFunctions.getDayNoForRRuleWeekDay)
                          .map(String)
                          .indexOf(`${index}`) !== -1
                      }
                      disabled={disabled}
                    />
                    <label htmlFor={`id-${day}`}>{day}</label>
                  </div>
                );
              })}
            </div>
          )}
          {_.get(formik.values, 'schedule_recurring.frequencytype') === RRULE_FREQUENCY_MAP[RRule.MONTHLY] && (
            <div>
              <div className="well">
                {'On '}
                <select
                  value={`${_.get(formik.values, 'schedule_recurring.bymonthday')}`}
                  name="schedule_recurring.bymonthday"
                  onChange={formik.handleChange}
                  disabled={disabled}
                >
                  {_.range(1, 31).map((n) => {
                    return (
                      <option key={`${n}`} value={`${n}`}>
                        {n}
                        th
                      </option>
                    );
                  })}
                </select>
                {' day of every '}
                <select
                  value={`${_.get(formik.values, 'schedule_recurring.monthlyinterval')}`}
                  name="schedule_recurring.monthlyinterval"
                  onChange={formik.handleChange}
                  disabled={disabled}
                >
                  {_.range(1, 13).map((n) => {
                    return (
                      <option key={`${n}`} value={`${n}`}>
                        {n}
                      </option>
                    );
                  })}
                </select>
                {' month'}
              </div>
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8} style={{ paddingRight: '1em' }}>
          <Form.Field>
            <label>START DATE</label>
            <input
              type="date"
              name="schedule_recurring.startdate"
              value={_.get(formik.values, 'schedule_recurring.startdate')}
              onChange={formik.handleChange}
              disabled={disabled}
            />
          </Form.Field>
        </Grid.Column>

        <Grid.Column width={8} style={{ paddingLeft: '1em' }}>
          <Form.Field>
            <label>End Date</label>
            <input
              type="date"
              name="schedule_recurring.enddate"
              value={_.get(formik.values, 'schedule_recurring.enddate')}
              onChange={formik.handleChange}
              disabled={disabled}
            />
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8} style={{ paddingRight: '1em' }}>
          <Form.Field>
            <label htmlFor="schedule_recurring.displayUptoDays">Display Occurences for up to next (days)</label>
            <input
              type="number"
              name="schedule_recurring.displayUptoDays"
              value={_.get(formik.values, 'schedule_recurring.displayUptoDays')}
              onChange={formik.handleChange}
              style={{ marginTop: '5px', marginRight: '5px' }}
              disabled={disabled}
              max={60}
              min={1}
            />
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={8} style={{ paddingRight: '1em', paddingLeft: '1em' }}>
          <Form.Field>
            <label>For Occurrences</label>
          </Form.Field>

          <Form.Field style={{ margin: '5px 0' }}>
            <input
              type="checkbox"
              name="schedule_recurring.overwriteEditedOccurrences"
              id="schedule_recurring.overwriteEditedOccurrences"
              checked={_.get(formik.values, 'schedule_recurring.overwriteEditedOccurrences')}
              onChange={formik.handleChange}
              style={{ marginTop: '5px', marginRight: '5px', cursor: 'pointer' }}
              disabled={disabled}
            />
            <label style={{ cursor: 'pointer' }} htmlFor="schedule_recurring.overwriteEditedOccurrences">
              Overwrite edited
            </label>
          </Form.Field>
          <Form.Field>
            <input
              type="checkbox"
              name="schedule_recurring.allowPileups"
              id="schedule_recurring.allowPileups"
              checked={_.get(formik.values, 'schedule_recurring.allowPileups')}
              onChange={formik.handleChange}
              style={{ marginTop: '5px', marginRight: '5px', cursor: 'pointer' }}
              // disabled={_.get(formik.values, 'schedule_recurring.overwriteEditedOccurrences')}
              disabled={disabled}
            />
            <label
              // disabled={_.get(formik.values, 'schedule_recurring.overwriteEditedOccurrences')}
              disabled={disabled}
              style={{ cursor: 'pointer' }}
              htmlFor="schedule_recurring.allowPileups"
            >
              Allow Pile-up
            </label>
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const BULK_EDIT_TASK = {
  taskNumber: '',
  attachments: [],
  taskTypeId: '',
  data: {
    s_name: '',
    s_workordernumber: '',
  },
  duration: '',
  eventSource: EVENT_SOURCE.MANUAL,
  priority: '',
  increment: null,
  status: '',
  assigneeIds: [],
  score: null,
  startTime: moment().add(1, 'hour').startOf('hour').toISOString(),
  schedule: null,
  isHardStartTime: false,
  onlyAllowManualScoreUpdate: false,
};

export const NEW_TASK = {
  assetId: '',
  attachments: [],
  taskTypeId: '',
  data: {
    s_name: '',
    s_workordernumber: '',
  },
  duration: 60, // default
  eventSource: EVENT_SOURCE.MANUAL,
  priority: '',
  increment: null,
  status: STATUS_LIST.OPEN.key,
  assigneeIds: [],
  score: null,
  startTime: moment().add(1, 'hour').startOf('hour').toISOString(),
  schedule: null,
  isHardStartTime: false,
  onlyAllowManualScoreUpdate: false,
};

export const PICKLIST_OPTIONS = {
  TASK_TYPE: 'taskTypeOptions',
  STOP: 'stopOptions',
  ASSIGNEE: 'assigneeOptions',
  ASSET: 'assetOptions',
  PRIORITY: 'priorityOptions',
  STATUS: 'statusOptions',
  EVENT_SOURCE: 'eventSourceOptions',
  NOTIFICATION_WATCHERS: 'notificationWatchers',
  PARTS_PICKLIST: 'partsPicklist',
  REQUESTERS: 'requesterOptions',
  WATCHER_GROUPS: 'watcherGroups',
  ASSET_LEVELS_OPTIONS: 'assetlevelOptions',
};

export const getPicklistOptionText = (picklistType) => {
  switch (picklistType) {
    case PICKLIST_OPTIONS.NOTIFICATION_WATCHERS:
    case PICKLIST_OPTIONS.ASSIGNEE: {
      return (entity) => `${entity.firstName} ${entity.lastName}`;
    }
    case PICKLIST_OPTIONS.ASSET: {
      return (entity) => `${entity.name} [${capitalizeFirstLetter(entity.type)}]`;
    }
    default:
      return (entity) => entity.name;
  }
};

export const getAssetsPreviewInfo = (assets) => {
  const assetsByType = _.groupBy(assets, 'type');
  const concatArray = [];

  for (const key of Object.keys(assetsByType)) {
    concatArray.push(`${assetsByType[key].length} ${capitalizeFirstLetter(key)}`);
  }
  return `Found ${concatArray.length ? concatArray.join(', ') : '0 assets'} matching criteria.`;
};

export function disabledFunctionForPicklist({ formValues, task }) {
  if (this.isChildTask === true) {
    return true;
  }
  if (this.parentId) {
    return _.isEmpty(formValues[this.parentId]);
  }
  return false;
}

export function buildPathFunctionForCustomAttributePicklist(attributeName) {
  return function pathFunctionForCustomAttributePicklist(task) {
    const picklistValue = _.get(task, `data.${attributeName}`);
    if (picklistValue && typeof picklistValue === 'object') {
      return picklistValue.id;
    }
    return picklistValue;
  };
}

export function buildPathFunctionForGlobalAttributePicklist(attributeName) {
  return function pathFunctionForGlobalAttributePicklist(task) {
    const picklistValue = _.get(task, `globalAttributes.${attributeName}`);
    if (picklistValue && typeof picklistValue === 'object') {
      return picklistValue.id;
    }
    return picklistValue;
  };
}

export function buildSetValueFunctionForCustomAttributePicklist(attributeName, attribute) {
  return function setValueFunctionForCustomAttributePicklist({ formValues, customPicklistOptions = {}, ...props }) {
    const picklistOptionId = _.get(formValues, attributeName);
    const picklistOptions = _.get(customPicklistOptions, `${attributeName}.items`);
    let picklistValue = {
      id: picklistOptionId || null,
      name: null,
    };
    if (attribute.type === 'metadatadynamiclist') {
      const reqOptions = attribute?.options({
        formValues,
        customPicklistOptions,
        ...props,
      });
      const picklistOptionsKeyedById = _.keyBy(reqOptions?.items ?? [], 'value');
      const name = picklistOptionsKeyedById[picklistOptionId]?.text ?? null;
      picklistValue = {
        id: picklistOptionId,
        name,
      };
    } else if (picklistOptionId && picklistOptions?.length) {
      const picklistName = picklistOptions.find((option) => option.value === picklistOptionId)?.text;
      picklistValue = {
        id: picklistOptionId,
        name: picklistName || null,
      };
    }
    return {
      data: {
        [attributeName]: picklistValue,
      },
    };
  };
}

export function buildSetValueFunctionForGlobalAttributePicklist(schemaAttributeName, attribute) {
  return function setValueFunctionForGlobalAttributePicklist({ formValues, customPicklistOptions, ...props }) {
    const actualAttributeName = attribute.name;
    const picklistOptionId = _.get(formValues, schemaAttributeName);
    const picklistOptions = _.get(customPicklistOptions, `${schemaAttributeName}.items`);
    let picklistValue = {
      id: picklistOptionId || null,
      name: null,
    };
    if (attribute.type === 'metadatadynamiclist') {
      picklistValue = {
        id: picklistOptionId,
        name: picklistOptionId,
      };
    } else if (picklistOptionId && picklistOptions?.length) {
      const picklistName = picklistOptions.find((option) => option.value === picklistOptionId)?.text;
      picklistValue = {
        id: picklistOptionId,
        name: picklistName || null,
      };
    }
    return {
      globalAttributes: {
        [actualAttributeName]: picklistValue,
      },
    };
  };
}

export function fetchOptionsForPicklist(picklistMappings, picklistDict, attrName, picklistSchema, formProps) {
  const { formValues, customPicklistOptions } = formProps;
  const picklistOptions = _.clone(
    _.get({ customPicklistOptions }, this.optionsVariableName, { isLoading: false, items: [] })
  );
  const attributeType = attrName.startsWith('c_')
    ? ATTRIBUTE_TYPE_IN_TASK.TASKTYPE_ATTRIBUTE
    : ATTRIBUTE_TYPE_IN_TASK.GLOBAL_ATTRIBUTE;
  if (this.type === 'picklist') {
    const pId = this.picklistId;
    const rId = this.mappingId;
    if (this.parentPickListIds && _.size(this.parentPickListIds)) {
      const reqMapping = picklistMappings.find((mapping) => mapping.id === rId);
      if (this.mappingId && reqMapping) {
        for (const parent of this.parentPickListIds) {
          const { attributeName, entity, picklistId, type } = parent;
          const selectedEntity = findSelectedEntity(formValues, entity);
          if (type === 'metadata' && selectedEntity) {
            const reqEntities = findRequiredEntities({
              entity,
              selectedEntity,
              ...formProps,
            });
            if (reqEntities) {
              const reqOption = findRequiredOptionForMetatdata({
                picklistDict,
                picklistId,
                reqEntities,
                attributeName,
              });
              if (reqOption) {
                const optionIds = findUniqueOptionsIds({ reqMapping, pId, reqOption });
                picklistOptions.items = picklistOptions.items.filter((option) => optionIds.includes(option.value));
              }
            }
          } else if (type === 'element') {
            const { val } = findValueInAnyParentElement({
              picklistSchema,
              formValues,
              parent,
              picklistDict,
              attributeType,
              ...formProps,
            });
            if (_.size(val)) {
              const optionIds = findUniqueOptionsIdsForElementType({ reqMapping, pId, val });
              picklistOptions.items = picklistOptions.items.filter((option) => optionIds.includes(option.value));
            }
          }
        }
      }
    }
  } else if (this.type === 'metadatadynamiclist') {
    picklistOptions.isLoading = false;
    const { entity, path, elementId, type, subPath } = this.metadataInfo;
    const selectedEntity = findSelectedEntity(formValues, entity);
    if (selectedEntity || entity === 'task') {
      const reqEntities = findRequiredEntities({
        entity,
        selectedEntity,
        ...formProps,
      });
      if (type === 'metadata') {
        picklistOptions.items = getUniqueOptionsForDynamicList({ reqEntities, path, subPath, entity });
      } else if (type === 'elementValue') {
        const { val, picklistId } = findElementValueAndPicklistId({ formValues, elementId, picklistSchema });
        if (val) {
          const reqPicklistOptions = picklistDict[picklistId] && picklistDict[picklistId].options;
          const reqOption = _.get(reqPicklistOptions, `[${val}]`);
          const reqItem = _.get(reqOption, `name`) || '';

          if (reqItem) {
            picklistOptions.items = getUniqueOptionsForDynamicList({ reqEntities, path, reqItem });
          }
        }
      }
    }
  }
  return picklistOptions;
}

const getFormField = ({ dynamicName, attributeObj, formik, task, defaultWidth, props }) => {
  if (attributeObj?.hasOwnGridStyle) {
    return <FormField attributeObj={attributeObj} formik={formik} task={task} dynamicName={dynamicName} {...props} />;
  }
  return (
    <>
      <Grid.Column width={defaultWidth} style={{ marginBottom: '10px' }}>
        <FormField attributeObj={attributeObj} formik={formik} task={task} dynamicName={dynamicName} {...props} />
      </Grid.Column>
      {attributeObj.fullRow && <Grid.Column width={16 - defaultWidth} />}
    </>
  );
};

export const TaskFormField = ({ attributeObj, formik, task, ...props }) => {
  const { width, ifSmallScreen } = props;
  const { componentWidth } = attributeObj;
  let defaultWidth = task.id ? 8 : 6;
  defaultWidth = componentWidth || width || defaultWidth;
  if (ifSmallScreen) {
    defaultWidth = 16;
  }
  const dynamicName =
    attributeObj?.dynamicNameFunc && typeof attributeObj.dynamicNameFunc === 'function'
      ? attributeObj.dynamicNameFunc({ taskType: props.taskType })
      : null;
  return (
    <>
      {!isFormAttributeHiddenOrInvalid(attributeObj, {
        formValues: formik.values,
        task,
        taskTypeSelectedisParent: props.taskTypeSelectedisParent,
        taskType: props.taskType,
        ...props,
      }) && getFormField({ dynamicName, attributeObj, formik, task, defaultWidth, props })}
    </>
  );
};

const findImmediateChild = ({ entityVal, entityType, formValues, ...props }) => {
  const { formik, customPicklistOptions, taskTypeOptions, assetOptions, stopOptions, assigneeOptions, attributes } =
    props;
  for (const [key, value] of Object.entries(attributes)) {
    const { parentPickListIds, metadataInfo, options } = value;

    if (value.type === 'picklist' && parentPickListIds && _.size(parentPickListIds)) {
      const { attributeName, entity, picklistId, type, elementId } =
        parentPickListIds.find(
          ({ type, entity, elementId }) =>
            (type === 'metadata' && entity === entityType) || (type === 'element' && elementId === entityType)
        ) || {};
      if (type === 'metadata' && entity === entityType) {
        const opts = options({
          formValues,
          customPicklistOptions,
          taskTypeOptions,
          assetOptions,
          stopOptions,
          assigneeOptions,
        });
        if (_.size(opts.items) === 1) {
          formValues = { ...formValues, [key]: opts.items[0].value };
          formik.setFieldValue(key, opts.items[0].value);
          findImmediateChild({
            entityVal,
            entityType: value.id,
            parentAttributeName: key,
            formValues,
            ...props,
          });
        } else if (_.size(opts.items) === 0 && formValues[key]) {
          formValues = { ...formValues, [key]: '' };
          formik.setFieldValue(key, '');
          findImmediateChild({
            entityVal,
            entityType: value.id,
            parentAttributeName: key,
            formValues,
            ...props,
          });
        }
      } else if (type === 'element' && elementId === entityType) {
        const opts = options({
          formValues,
          customPicklistOptions,
          taskTypeOptions,
          assetOptions,
          stopOptions,
          assigneeOptions,
        });
        if (_.size(opts.items) === 1) {
          formValues = { ...formValues, [key]: opts.items[0].value };
          formik.setFieldValue(key, opts.items[0].value);
          findImmediateChild({
            entityVal,
            entityType: value.id,
            parentAttributeName: key,
            formValues,
            ...props,
          });
        } else if (_.size(opts.items) === 0 && formValues[key]) {
          formValues = { ...formValues, [key]: '' };
          formik.setFieldValue(key, '');
          findImmediateChild({
            entityVal,
            entityType: value.id,
            parentAttributeName: key,
            formValues,
            ...props,
          });
        }
      }
    } else if (value.type === 'metadatadynamiclist' && metadataInfo) {
      const { entity, elementId, type } = metadataInfo;
      if (type === 'metadata' && entity === entityType) {
        const opts = options({
          formValues,
          customPicklistOptions,
          taskTypeOptions,
          assetOptions,
          stopOptions,
          assigneeOptions,
        });
        if (_.size(opts.items) === 1) {
          formValues = { ...formValues, [key]: opts.items[0].value };
          formik.setFieldValue(key, opts.items[0].value);
        } else if (_.size(opts.items) === 0 && formValues[key]) {
          formValues = { ...formValues, [key]: '' };
          formik.setFieldValue(key, '');
        }
      } else if (type === 'elementValue') {
        let reqVal = null;
        for (const [key, value] of Object.entries(attributes)) {
          if (value.id === elementId) {
            reqVal = formValues[key];
          }
        }
        if (reqVal) {
          const opts = options({
            formValues,
            customPicklistOptions,
            taskTypeOptions,
            assetOptions,
            stopOptions,
            assigneeOptions,
          });
          if (_.size(opts.items) === 1) {
            formValues = { ...formValues, [key]: opts.items[0].value };
            formik.setFieldValue(key, opts.items[0].value);
          } else if (_.size(opts.items) === 0 && formValues[key]) {
            formValues = { ...formValues, [key]: '' };
            formik.setFieldValue(key, '');
          }
        } else if (formValues[key]) {
          formValues = { ...formValues, [key]: '' };
          formik.setFieldValue(key, '');
        }
      }
    }
  }
};

export const findAffectingChild = ({
  attributes,
  entityVal,
  entityType,
  formik,
  formValues,
  customPicklistOptions,
  taskTypeOptions,
  assetOptions,
  assigneeOptions,
  stopOptions,
}) => {
  findImmediateChild({
    attributes,
    entityVal,
    entityType,
    formik,
    customPicklistOptions,
    taskTypeOptions,
    assetOptions,
    assigneeOptions,
    formValues,
    stopOptions,
  });
};

export const MARKER_TYPE = {
  STOP_MARKER: 'STOP MARKER',
  RESOLVED_AT_MARKER: 'RESOLVED_AT_MARKER',
};

export const RESOLVED_VIA = {
  MOBILE: 'Mobile',
  ADMIN: 'Admin',
};

export const APPROVAL_ACTION_MESSAGE = {
  [APPROVAL_OPTIONS.DENY.key]: (type, limit, comment) => {
    return `${type} denied for ${limit} Limit with comment "${comment}"`;
  },
  [APPROVAL_OPTIONS.ON_HOLD.key]: (type, limit, comment) => {
    return `${type} on Hold for ${limit} Limit with comment "${comment}"`;
  },
  [APPROVAL_OPTIONS.NEED_MORE_INFO.key]: (type, limit, comment) => {
    return `${type} need more info for ${limit} Limit with comment "${comment}"`;
  },
  [APPROVAL_OPTIONS.APPROVE.key]: (type, limit) => {
    return `${type} approved for ${limit} Limit`;
  },
};

export const marginBottom = (url) => {
  const urlString = _.get(url, 'location.pathname', '');
  if (urlString) {
    if (urlString.includes('/taskViewPage') && !urlString.includes('/new')) {
      return '80px';
    }
    if (urlString.includes('/taskViewPage') && urlString.includes('/new')) {
      return '80px';
    }
    if (urlString.includes('/requestViewPage') && urlString.includes('/new')) {
      return '80px';
    }
  }
  return '80px';
};

export const styleObj = (url) => {
  const urlString = _.get(url, 'location.pathname', '');

  if (urlString) {
    if (urlString.includes('/requestViewPage') && urlString.includes('/new')) {
      return {
        width: 'calc(100% - 66px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(-50%, 0%)',
        left: 'calc(50% + 8px)',
      };
    }
    if (urlString.includes('/requestViewPage') && !urlString.includes('/new')) {
      return {
        width: 'calc(68.75% - 65px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(0%, 0%)',
        left: '42px',
      };
    }
    if (urlString.includes('/taskViewPage') && !urlString.includes('/new')) {
      return {
        width: 'calc(68.75% - 65px)',
        transform: 'translate(0%, 0%)',
        left: '27px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    }
    if (urlString.includes('/taskViewPage') && urlString.includes('/new')) {
      return {
        width: 'calc(100% - 66px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(-50%, 0%)',
      };
    }
  }
  return {};
};
